import { Link } from "react-router-dom";

import { logo1881 } from "../../assets/img";
import UserNav from "./UserNav";

const MainNav = () => {
  return (
    <nav className="navbar fixed-top navbar-dark bg-primary">
      <div className="container-fluid">
        <span className="navbar-brand mb-0 h1">
          <a href="https://www.1881.no" style={{color: "white"}}><img
              src={logo1881}
              alt="Opplysningen 1881"
              className="cc-logo-1881"
            /></a>
          <Link to="/" className="text-white">
            <span>Min bedrift</span>
          </Link>
        </span>
        <UserNav />
      </div>
    </nav>
  );
};

export default MainNav;
